import { Box, Skeleton } from '@mui/material';

export const TabBarSkeleton = ({ tabCount = 7 }) => (
  <Box display="flex" gap="12px" flexWrap="wrap" mb="20px" aria-hidden="true">
    {Array.from({ length: tabCount }).map((_, index) => (
      <Skeleton key={index} variant="rounded" width={110} height={36} />
    ))}
  </Box>
);
